import { theme } from "../../theme";
export const badgeTemplateList = {
    wrapper: {},
    topActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    cardItem: {
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "6px",
      height: "100%",
      cursor: "pointer",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#fff",

      "&:hover": {
        borderColor: theme.palette.primary.main,
      },
    },
    cardContent: {
      display: "flex",
      paddingTop: "25px",
      paddingBottom: "25px !important",
      paddingLeft: "25px",
      paddingRight: "25px",
      position: "relative",
      height: "calc(100% - 50px)",

      "&:hover cardActions": {
        visibility: "visible",
      },
    },

    cardActions: {
      position: "absolute",
      bottom: "0px",
      right: "7px",
      color: theme.palette.primary.main,
      visibility: "hidden",
    },
  } as const;

  export const badgeDesigner = {
    wrapper: {},
    topActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "10px",
    },
  };